import React from "react";
import { Spin, DatePicker, Message } from "../../../BP2Components";
import { isFieldDisabled } from "./FormFIeldsV3Decorators";

import "../formsV3.less";
import { parse, format, isValid, startOfDay, addDays } from "date-fns";
import { useIntl } from "react-intl";
import { useFieldController } from "../../../../util/useFieldController";

const DEFAULT_DATE_FORMAT = "yyyy-MM-dd";

const normalizeDateValue = (input) => {
   if (input === null || input === undefined) return "";
   if (typeof input === "string") return input;
   if (typeof input === "object") {
      return input.originalValue ?? input.decoratedValue ?? "";
   }
   return "";
};

const getDecoratorByName = (decoratorsList, decoratorName) =>
   (decoratorsList ?? []).find((decorator) => decorator?.name === decoratorName) || null;

const getDateFormat = (decoratorsList) => {
   const valueFormatDecorator = getDecoratorByName(decoratorsList, "ValueFormatDecorator");
   return valueFormatDecorator?.properties?.format || DEFAULT_DATE_FORMAT;
};

const FormV3DateField = ({ field, formGUID, loading, decorators, onValueChange }) => {
   const { value, setValue, fieldInfo } = useFieldController({
      field,
      formGUID,
      onValueChange,
   });
   const intl = useIntl();
   const allDecorators = field?.decorators ?? decorators ?? [];

   const parseDateRangeBound = (boundValue, dateFnsFormat) => {
      if (boundValue === null || boundValue === undefined || boundValue === "") return undefined;

      const trimmedValue = String(boundValue).trim();

      if (/^-?\d+$/.test(trimmedValue)) {
         const offsetDays = Number(trimmedValue);
         if (!Number.isFinite(offsetDays)) return undefined;
         return startOfDay(addDays(new Date(), offsetDays));
      }

      const parsed = parse(trimmedValue, dateFnsFormat, new Date());
      return isValid(parsed) ? startOfDay(parsed) : undefined;
   };

   const dateFormat = getDateFormat(allDecorators);

   const dateRangeDecorator = getDecoratorByName(allDecorators, "DateRangeDecorator");
   const minDate = parseDateRangeBound(dateRangeDecorator?.properties?.from, dateFormat);
   const maxDate = parseDateRangeBound(dateRangeDecorator?.properties?.to, dateFormat);

   const handleValueChange = (date) => {
      if (!date) {
         setValue("");
         return;
      }

      const dateObj = date instanceof Date ? date : new Date(date);
      if (!isValid(dateObj)) {
         Message.error(intl.formatMessage({ id: "formv3.invalid_date_format" }));
         return;
      }

      setValue(format(dateObj, DEFAULT_DATE_FORMAT));
   };

   return (
      <>
         <span className={`v3-field-element`}>
            <div className="datapicker-wrapper">
               <DatePicker
                  style={{ width: "100%" }}
                  wrapperClassName="datapicker-wrapper__wrapper-class-name"
                  disabled={isFieldDisabled(field)}
                  className={`v3-field id-${field.id}`}
                  value={normalizeDateValue(value)}
                  onChange={handleValueChange}
                  minDate={minDate}
                  maxDate={maxDate}
                  format={dateFormat}
               />
            </div>
            <span className="p2 dev-info">{`${field.id}`}</span>
            {fieldInfo ? <div className="validation-error">{`${fieldInfo}`}</div> : null}
         </span>
         {loading && <Spin></Spin>}
      </>
   );
};

export default FormV3DateField;
